import React from 'react';
import PropTypes from 'prop-types';
import UserFeedbackCompleted
  from 'Components/ComponentLibrary/Organisms/UserFeedback/UserFeedbackPicker/UserFeedbackCompleted/UserFeedbackCompleted';
import UserFeedbackQuestion
  from 'Components/ComponentLibrary/Organisms/UserFeedback/UserFeedbackPicker/UserFeedbackQuestion/UserFeedbackQuestion';

const UserFeedbackPicker = ({ hasSubmittedFeedback, ...rest }) => {
  if (!hasSubmittedFeedback) {
    return (<UserFeedbackQuestion {...rest} />);
  }

  return <UserFeedbackCompleted {...rest} />;
};

UserFeedbackPicker.defaultProps = {
};

UserFeedbackPicker.propTypes = {
  hasSubmittedFeedback: PropTypes.bool.isRequired,
};

export default UserFeedbackPicker;
